import React from 'react'
import { navigate } from 'gatsby'
import { useInView } from 'react-intersection-observer'

import Button from '../../atoms/button/button'

import iconoMujerParticipa from '../../../assets/images/iconoMujerParticipa.png'
import premioParticipa from '../../../assets/images/premioParticipa.png'

import pushEventDataLayer from '../../../utils/pushEventDataLayer'

import { siteUrl } from '../../../shared/utils/siteUrl'

import './participaSection.scss'
import { costActivity } from '../../../constants/activity-constants'
import getUrlIdRegister from '../../../utils/getUrlIdRegister'

const ParticipaSection = ({ isMobile }) => {
  const [ref, inView] = useInView({ threshold: 0.8, triggerOnce: true })
  const [ref2, inView2] = useInView({ threshold: 0.9, triggerOnce: true })
  const [ref3, inView3] = useInView({ threshold: 0.9, triggerOnce: true })
  const [ref4, inView4] = useInView({ threshold: 0.9, triggerOnce: true })
  const [ref5, inView5] = useInView({ threshold: 0.5, triggerOnce: true })
  return (
    <div className="f-participaSection-container">
      <div
        id="como-participo"
        className="f-participaSection-container__ancla"
      />
      <h1 className="f-participaSection-container__titleSection">
        ¿Cómo participo?
      </h1>
      <div className="f-participaSection-container__wrapper">
        <section className="f-participaSection-container__steps">
          <div
            className={`f-participaSection-container__steps__item item1 ${
              inView ? 'animacion' : ''
            }`}
            ref={ref}
          >
            <figure className="f-participaSection-container__steps__item__gotaNumero">
              <b>1</b>
            </figure>
            <h2>Inicia sesión</h2>
            <p>
              <span>¿Ya haces parte de NosotrasOnline?</span> Para poder jugar
              debes <a onClick={() => navigate('/jugar')}>Iniciar sesión </a> Si
              aún no estás registrada, <br />
              <br /> ¡No tienes de qué preocuparte!
            </p>
            <Button
              title="Regístrate aquí"
              size="f-large"
              color="f-blue"
              onClick={() => {
                pushEventDataLayer(
                  'Interacciones - Registro',
                  'cur-v-shooter',
                  'click registro',
                  'registrate aqui'
                )
                window.open(
                  siteUrl + getUrlIdRegister(),
                  '_blank'
                )
              }}
            />
          </div>
          {!isMobile && (
            <img
              src={iconoMujerParticipa}
              alt="mujer representando la marca nosotras"
              className="f-participaSection-container__steps__item__imgMujer"
            />
          )}
          <div
            className={`f-participaSection-container__steps__item item2 ${
              inView ? 'animacion' : ''
            }`}
          >
            <figure className="f-participaSection-container__steps__item__gotaNumero">
              <b>2</b>
            </figure>
            <h2>Redime puntos</h2>
            <p>
              <span>
                Para poder jugar debes redimir <br /> de tus puntos acumulados.{' '}
                <span className="f-romboPuntos">
                  <b className="f-romboPuntos__numero">{costActivity}</b>
                </span>{' '}
                <br />
                <br />
                Si aún no tienes ¡puedes estar tranquila! Inscribe las claves de
                tus productos Nosotras
              </span>
            </p>
            <Button
              title="Aquí"
              size="f-small"
              color="f-blue"
              onClick={() => {
                pushEventDataLayer(
                  'Interacciones - Registro Claves',
                  'cur-v-shooter',
                  'click redimir',
                  'aqui'
                )
                window.open(siteUrl + '/mis-puntos/que-son/', '_blank')
              }}
            />
          </div>
          <div
            className={`f-participaSection-container__steps__item item3 ${
              inView2 ? 'animacion' : ''
            }`}
            ref={ref2}
          >
            <figure className="f-participaSection-container__steps__item__gotaNumero">
              <b>3</b>
            </figure>
            <h2>Juega</h2>
            <p>
              <span>¿Tú misión?</span> <br /> <br />
              <span>
                Derribar las gotas de sangre, encontrar las cajitas mágicas
                ubicadas debajo de las gotas azules{' '}
              </span>{' '}
              y poner a prueba tu conocimiento. <br /> <br />
              <span>¡Direcciona tu tiro y dispara!</span>
            </p>
          </div>
        </section>
        <section className="f-participaSection-container__stepsBox">
          <div
            className={`f-participaSection-container__stepsBox__box box1 ${
              inView3 ? 'animacion' : ''
            }`}
            ref={ref3}
          >
            <figure className="f-participaSection-container__stepsBox__box__rombo iconGotaRoja" />
            <p>
              <span> 1 disparo </span>para derribar <br /> cada gota de sangre.
            </p>
          </div>
          <div
            className={`f-participaSection-container__stepsBox__box box2 ${
              inView3 ? 'animacion' : ''
            }`}
          >
            <figure className="f-participaSection-container__stepsBox__box__rombo iconGotaAzul" />
            <p className="f-itemB">
              <span> ¡Descubre las gotas azules! </span> <br />
              Allí encontrarás las cajitas mágicas, y con solo{' '}
              <span> 3 disparos, </span>las podrás derribar.
            </p>
          </div>
          <div
            className={`f-participaSection-container__stepsBox__box box3 ${
              inView3 ? 'animacion' : ''
            }`}
          >
            <figure className="f-participaSection-container__stepsBox__box__rombo iconExplocion" />
            <p className="f-itemA">
              <span>¡Boom!</span> La cajita explotará y tendrás que responder,
              en 50 segundos, una pregunta para seguir jugando. <br />
              <span> ¡Gana 6 puntos con cada respuesta correcta!</span>
            </p>
          </div>
          <div
            className={`f-participaSection-container__stepsBox__box box4 mt-30 ${
              inView4 ? 'animacion' : ''
            }`}
            ref={ref4}
          >
            <figure className="f-participaSection-container__stepsBox__box__rombo iconGotaRosa" />
            <p className="f-itemA">
              <span>
                {' '}
                Localiza las gotas rosadas y allí encontrarás los bonus tracks.
              </span>{' '}
              ¡Tendrás 15 segundos para que las derribes!
            </p>
          </div>
          <div
            className={`f-participaSection-container__stepsBox__box box5 mt-30 ${
              inView4 ? 'animacion' : ''
            }`}
          >
            <figure className="f-participaSection-container__stepsBox__box__rombo iconPlay" />
            <p className="f-itemA">
              <span> ¡Dale play al video!</span> Te ayudará a resolver el reto
              <span> y ganarás 6 puntos adicionales.</span> <br /> <br /> Dale
              skip si quieres continuar *(No ganarás puntos)
            </p>
          </div>
        </section>
        <section className="f-participaSection-container__buttonDown">
          <h2>¿Lista para jugar?</h2>
          <Button
            title="¡Haz clic acá!"
            size="f-large"
            color="f-blue"
            onClick={() => {
              pushEventDataLayer(
                'Interacciones - Lista para jugar',
                'cur-v-shooter',
                'click juego',
                'haz clic aca'
              )
              navigate('/jugar')
            }}
          />
        </section>
        <section className="f-participaSection-container__awards" ref={ref5}>
          <img
            className={`f-participaSection-container__awards__imgPremio ${
              inView5 ? 'animacion' : ''
            }`}
            src={premioParticipa}
            alt="premio que ganaran las usuarias"
          />
          <div
            className={`f-participaSection-container__steps__item item4 ${
              inView5 ? 'animacion' : ''
            }`}
          >
            <figure className="f-participaSection-container__steps__item__gotaNumero">
              <b>4</b>
            </figure>
            <h2>Gana</h2>
            <p>
              <span>
                Del top 1 al 100 ganarán un fabuloso kit <br /> de productos
                Nosotras + merchandising
              </span>{' '}
              <br /> <br />
              Antes de jugar, conoce todos los{' '}
              <span>términos y condiciones</span>{' '}
              <a href="#terminos-y-condiciones">aquí</a> <br /> <br />
              Ahora sí, ¡pon a prueba tu destreza y conocimiento y gana!
            </p>
            <Button
              title="¡Quiero jugar!"
              size="f-large"
              color="f-blue"
              onClick={() => {
                pushEventDataLayer(
                  'Interacciones - Quiero jugar',
                  'cur-v-shooter',
                  'click juego',
                  'quiero jugar'
                )
                navigate('/jugar')
              }}
            />
          </div>
        </section>
      </div>
    </div>
  )
}

export default ParticipaSection
